'use strict';

angular.module('substoreApp.controllers').controller('languageController', ['$scope', 'sessionData', 'uiservice', '$filter', '$window',
    function ($scope, sessionData, uiservice, $filter, $window) {

        $scope.languageChanged = function (arg) {

            // get dialog data (if session data is ready)
            sessionData.promise.then(function () {

                sessionData.dialogStaticData.language = arg.toLowerCase();
                sessionData.storeSessionData();

                // inform server about the new language for this user
                // note that we completely ignore any errors here (e.g. session expired),
                // so that this language switch even works in error dialogs
                uiservice.setLanguage({ sessionId: sessionData.sessionId, lang: arg},
                    function success(response) {
                        $window.location.reload();
                    },
                    $scope.throwServiceResponseFault
                );
            });

            return false;
        };

        sessionData.promise.then(function () {
            $scope.options = [];
            var index = 0;
            var pos = 0;
            angular.forEach(sessionData.dialogStaticData.availableLanguages, function (lang) {
                var langCode = lang.toLowerCase();
                if (sessionData.dialogStaticData.language.toLowerCase() == langCode) {
                    index = pos;
                }
                pos++;
                $scope.options.push({
                    value: langCode.toUpperCase(),
                    iso: langCode.toLowerCase(),
                    label: 'language_' + langCode.toUpperCase()
                });
            });

            if (pos < 2) {
                $('.language_selection').hide();
            }
        });

    }]);
